const en = {
  // Navigation
  home: "Home",
  products: "Products",
  about: "About Us",
  contact: "Contact",
  
  // Hero Section
  heroTitle: "Loveish",
  heroSlogan: "Taste the Love",
  heroDescription: "Discover our premium collection of dried fruits, nuts, sweets, pickles, and jams. Made with love, delivered with care.",
  shopNow: "Shop Now",
  learnMore: "Learn More",
  
  // Products
  driedFruits: "Dried Fruits",
  driedFruitsDesc: "Premium quality dried fruits packed with natural sweetness",
  nuts: "Nuts",
  nutsDesc: "Fresh and nutritious nuts for healthy snacking",
  sweets: "Sweets",
  sweetsDesc: "Traditional Persian sweets made with authentic recipes",
  pickles: "Pickles",
  picklesDesc: "Delicious pickled vegetables and olives",
  jams: "Jams",
  jamsDesc: "Homemade jams bursting with natural fruit flavors",
  
  // Product Items
  walnuts: "Walnuts",
  almonds: "Raw and Salted Almonds",
  pistachios: "Raw, Saffron and Salted Pistachios",
  peanuts: "Peanuts",
  hazelnuts: "Hazelnuts",
  chickpeas: "Chickpeas and Raisins",
  
  mangoLeaves: "Mango Leaves",
  peaches: "Peaches",
  plums: "Plums",
  apple: "Apple",
  banana: "Banana",
  strawberries: "Strawberries",
  yellowPlums: "Yellow Plums",
  pineapples: "Pineapples",
  figs: "Figs",
  bukharaPlums: "Bukhara Plums",
  
  gaz: "Gaz",
  sohan: "Sohan",
  latifeh: "Latifeh",
  kalampeh: "Kalampeh",
  fasaeiBread: "Fasaei Bread",
  datesArdeh: "Dates and Ardeh",
  iceCream: "Ice Cream and Faloodeh",
  pashmak: "Pashmak Haj Abdullah",
  
  lyte: "Various Types of Lyte",
  pearlGarlic: "Pearl Garlic",
  olives: "Olives",
  cultivatedOlives: "Cultivated Olives",
  
  strawberryJam: "Strawberry Jam",
  carrotJam: "Carrot Jam",
  blackcurrantJam: "Blackcurrant Jam",
  honey: "Honey",
  
  // About
  aboutTitle: "About Loveish",
  aboutDescription: "We are passionate about bringing you the finest selection of traditional and modern food products. Our commitment to quality and authentic flavors makes every bite a memorable experience.",
  
  // Contact
  contactTitle: "Get in Touch",
  contactDescription: "We'd love to hear from you. Contact us for any inquiries about our products.",
  messageSentSuccess: "Thank you! Your message has been sent successfully.",
  messageSentError: "Oops! Something went wrong. Please try again.",
  
  // Footer
  quickLinks: "Quick Links",
  followUs: "Follow Us",
  allRightsReserved: "All rights reserved",
  footerDescription: "Premium Persian nuts, dried fruits, traditional sweets, and artisanal products delivered with love.",
  customerService: "Customer Service",
  faq: "FAQ",
  privacyPolicy: "Privacy Policy",
  support: "Support",
  newsletter: "Newsletter",
  newsletterDescription: "Subscribe to get special offers and updates",
  enterEmail: "Enter your email",
  subscribe: "Subscribe",
  
  // Common
  viewAll: "View All",
  addToCart: "Add to Cart",
  buyNow: "Buy Now",
  shoppingCart: "Shopping Cart",
  emptyCart: "Your cart is empty",
  clearCart: "Clear Cart",
  checkout: "Checkout",
  total: "Total",
  checkoutSuccess: "Thank you for your order! We will contact you soon.",
  
  // Cart Page
  cartItems: 'Cart Items',
  clearAll: 'Clear All',
  continueShopping: 'Continue Shopping',
  orderSummary: 'Order Summary',
  freeShippingProgress: 'Free Shipping Progress',
  subtotal: 'Subtotal',
  shipping: 'Shipping',
  tax: 'Tax',
  calculatedAtCheckout: 'Calculated at checkout',
  proceedToCheckout: 'Proceed to Checkout',
  havePromoCode: 'Have a Promo Code?',
  enterCode: 'Enter code',
  apply: 'Apply',
  whyShopWithUs: 'Why Shop With Us?',
  securePayment: '100% Secure Payment',
  returnPolicy: '30-Day Return Policy',
  customerSupport: '24/7 Customer Support',
  qualityGuaranteed: 'Premium Quality Guaranteed',
  clearCartConfirm: 'Clear Cart?',
  clearCartMessage: 'Are you sure you want to remove all items from your cart? This action cannot be undone.',
  cancel: 'Cancel',
  itemTotal: 'Item Total',
  addMoreForFreeShipping: 'Add {amount} more for free shipping!',
  yourCartIsEmpty: 'Your Cart is Empty',
  emptyCartMessage: 'Looks like you haven\'t added any items yet. Start shopping and discover our amazing products!',
  startShopping: 'Start Shopping',
  yourCart: 'Your Cart',
  
  // Products Page
  ourProducts: "Our Products",
  searchProducts: "Search products...",
  featuredCategories: "Featured Categories",
  specialGifts: "Special Gifts",
  
  // Auth
  login: "Login",
  logout: "Logout",
  profile: "Profile",
  welcomeBack: 'Welcome Back',
  loginToAccount: 'Login to your account',
  createAccount: 'Create Account',
  joinLoveish: 'Join Loveish today',
  email: 'Email',
  password: 'Password',
  confirmPassword: 'Confirm Password',
  firstName: 'First Name',
  lastName: 'Last Name',
  enterEmail: 'Enter your email',
  enterPassword: 'Enter your password',
  enterFirstName: 'Enter your first name',
  enterLastName: 'Enter your last name',
  signIn: 'Sign In',
  signingIn: 'Signing In...',
  creatingAccount: 'Creating Account...',
  forgotPassword: 'Forgot Password?',
  verificationEmailSent: 'Verification Email Sent!',
  checkEmailToVerify: 'Please check your email and click the verification link to activate your account.',
  emailVerified: 'Email Verified Successfully!',
  canNowLogin: 'You can now log in to your account.',
  soldOut: 'SOLD OUT',
  comingSoon: 'Coming Soon',
  notifyWhenAvailable: 'Notify me when available',
  outOfStock: 'Out of Stock'
};

export default en;